export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_UNIQUE_PRODUCT = 'GET_UNIQUE_PRODUCT';
export const GET_PRODUCTS_BY_USER_ID = 'GET_PRODUCTS_BY_USER_ID';
